<template>
  <v-bottom-sheet v-model="showProfileSheet" persistent fullscreen scrollable class="profile-sheet-main">
    <v-sheet class="profile-sheet">
      <div class="profile-sheet-wrapper">
        <div class="profile-sheet-header">
          <!-- <v-img src="/static/image/profile/member-header-bg.png" :contain="true" class="profile-sheet-header-image"></v-img> -->
          <div class="profile-sheet-header-wrapper">
            <div class="profile-sheet-close-wrapper" @click="closeProfileSheet">
              <v-icon class="profile-sheet-close-icon">mdi-close</v-icon>
            </div>
            <div class="header-member-name">
              <v-avatar size="84" class="profile-sheet-profile-avatar">
                <div>
                  {{ memberInfo.name ? memberInfo.name.slice(0, 1).toUpperCase() : memberInfo.memberCode.slice(0, 1).toUpperCase() }}
                </div>
                <!-- <v-img src="/static/image/profile/member-header-bg.png" :contain="true" class="profile-sheet-header-image"></v-img> -->
              </v-avatar>
              <div style="color: #fff">{{ memberInfo.name || memberInfo.memberCode }}</div>
            </div>
            <!--            <div class="profile-rightside">-->
            <!--              <span>{{ $t(`label.nagad88ladderboardlevel`) }}</span>-->
            <!--              <br />-->
            <!--              <div class="containerimg">-->
            <!--                <img src="/static/image/profile/level-container.png" width="115px" />-->
            <!--                <div class="text-overlay">-->
            <!--                  <span>{{ currentLvlName }}</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="profile-sheet-body">
          <div class="profile-sheet-body-wrapper">
            <div class="profile-sheet-item">
              <div v-if="isLoggedIn" class="balance-details" :class="[tierColorThemeName]">
                <v-row no-gutters class="MB-row pa-3">
                  <v-col class="MB-left-col ">
                    <v-row style="margin-top: 10px; margin-bottom: 10px;" no-gutters>
                      <v-col cols="11">
                        <span class="membercode-span highlighted-span">
                          {{ $t(`label.viptierlevel`) }} :
                          <span style="text-transform: uppercase;text-align: center">{{ tierName }}</span>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="11" style=" margin-bottom: 10px;">
                        <v-progress-linear class="customized-progressbar" :class="[tierColorThemeName]" :value="currentProgressPercentage" size="20" :background-color="`viptier${tierColorThemeName}`">
                          <span style="color: #fff; font-size: 10px">{{ currentDeposit }} / {{ requiredDeposit }}</span>
                        </v-progress-linear>
                      </v-col>
                      <v-col cols="11" class="progress-details-col" style="color: #FFFFFF; font-weight: normal; margin-bottom: 10px;">
                        <span v-if="tierColorThemeName === 'black'">{{ $t('label.highestlevelreach') }}</span>
                        <span v-else>
                          {{ $t('label.upgradetonextlevel') }}
                          {{ nextlevelname }}
                          {{ $t('label.nextlevel') }}
                          <br />
                          {{ $t('label.depositRequired') }}{{ progressRequired }}
                          <br />
                          {{ $t('label.turnoverRequired') }}{{ turnoverRequired }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3" class="MB-right-col d-flex align-center">
                    <v-row class="justify-space-around">
                      <v-avatar tile class="vip-tier-current" style="height:90px; width:150px; margin-top: 10px;">
                        <!--                        <v-img v-if="memberVipTierProgress && memberVipTierProgress.image" :src="`${memberVipTierProgress.image}`"></v-img>-->
                        <!--                        <v-img v-else :src="`/static/svg/mobileAccount/vip_${tierColorThemeName}.svg`" eager></v-img>-->
                        <!--                        <img src="/static/image/profile/crown.png"/>-->
                        <v-img :src="`/static/svg/vipassets/${tierColorThemeName}_vip.png`"></v-img>
                      </v-avatar>
                      <!--          <div>-->
                      <!--            viptier badge-->
                      <!--          </div>-->
                    </v-row>
                    <!--                    <v-row>-->
                    <!--                      <span style="text-transform: uppercase;text-align: center">{{tierName}}</span>-->
                    <!--                    </v-row>-->
                  </v-col>
                </v-row>
                <v-row class="MB-btm-row px-3" no-gutters @click="goToTierDetails">
                  <v-col cols="10">
                    <span style="font-size: 12px;color: #FFF; font-weight: normal;">{{ $t(`label.viewMemberShip`) }}</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-icon color="white">mdi-chevron-right</v-icon>
                </v-row>
              </div>
            </div>
            <v-row no-gutters class="guideSectionProfile" v-if="showVoucherGuide">
              <v-col class="pa-0" cols="11">
                <div class="d-flex align-center">
                  <img src="/static/image/profile/guideIcons.png" width="25" height="25" :contain="true" />
                  <label class="px-3">
                    {{ $t(`label.voucherGuide`) }} {{ $t(`label.clickThis`) }}
                    <a href="https://nagad88.wistia.com/medias/dgbh5t9e7l" target="_blank" class="linkText">{{ $t(`label.link`) }}</a>
                    {{ $t(`label.watchVideo`) }}
                  </label>
                </div>
              </v-col>
              <v-col cols="1" class="pa-0 d-flex justify-center align-center">
                <v-img @click="closeShowVoucherGuide()" src="/static/image/profile/closeIcon.png" width="15" height="15" :contain="true"></v-img>
              </v-col>
            </v-row>
            <div class="profile-sheet-item profile-sheet-wallet">
              <div class="profile-sheet-balance">
                <label style="font-size: 16px;">{{ $t(`label.mainWallet`) }}</label>
                <div @click="getMemberWallet()" class="refresh-balance-icon"></div>
                <div @click="maskBalance()">
                  <v-icon v-if="showBalance" class="mask-balance">mdi-eye-off</v-icon>
                  <v-icon v-else class="mask-balance">mdi-eye-settings</v-icon>
                </div>
              </div>
              <div>
                <label class="text-capitalize balance" v-if="notLoading">
                  <span v-if="showBalance">{{ memberWallet.totalBalance | currency(currentCurrency) | maskNumber }}</span>
                  <span v-else>{{ memberWallet.totalBalance | currency(currentCurrency) }}</span>
                </label>
                <v-progress-circular indeterminate v-if="!notLoading" color="amber" :width="3" :size="24"></v-progress-circular>
              </div>
            </div>
            <v-row no-gutters class="guideSectionProfile" @click="goToReferral">
              <v-col class="pa-0 d-flex" cols="12">
                <v-col cols="11" class="pa-0 d-flex align-center">
                  <img src="/static/image/profile/profile-referral.png" width="35" height="35" alt="referral" />
                  <span class="pl-2" style="font-size: 16px; font-weight: bolder;">{{ $t(`label.referralRedirect`) }}</span>
                </v-col>
                <v-col cols="1" class="pa-0 d-flex justify-end">
                  <v-icon color="#0047ff">mdi-chevron-right</v-icon>
                </v-col>
              </v-col>
            </v-row>
            <div class="profile-sheet-item">
              <div class="profile-sheet-item-header">
                <div class="profile-sheet-item-title">{{ $t(`label.fund`) }}</div>
              </div>
              <div class="profile-sheet-item-divider"></div>
              <div :class="$vuetify.breakpoint.mdAndDown ? 'profile-sheet-item-row-mobile' : 'profile-sheet-item-row'">
                <div class="profile-sheet-item-column" @click="routeTo('DEPOSIT')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-deposit.png" width="39" height="39" alt="deposit icon" />
                  </div>
                  <label>{{ $t(`label.deposit`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="routeTo('WITHDRAWAL')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-withdraw.png" width="39" height="39" alt="withdrawal icon" />
                  </div>
                  <label>{{ $t(`label.withdrawal`) }}</label>
                </div>
                <div v-if="false" class="profile-sheet-item-column" @click="routeTo('REBATE')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-bonus.png" width="39" height="39" alt="rebate" />
                  </div>
                  <label>{{ $t(`label.InstantRebate`) }}</label>
                </div>
              </div>
            </div>
            <div class="profile-sheet-item">
              <div class="profile-sheet-item-header">
                <div class="profile-sheet-item-title">{{ $t(`label.history`) }}</div>
              </div>
              <div class="profile-sheet-item-divider"></div>
              <div :class="$vuetify.breakpoint.mdAndDown ? 'profile-sheet-item-row-mobile' : 'profile-sheet-item-row'">
                <div class="profile-sheet-item-column" @click="routeTo('BETTING_RECORD')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-betting-record.png" width="39" height="39" alt="total icon" />
                  </div>
                  <label>{{ $t(`label.bettingRecors`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="routeTo('TURNOVER_RECORD')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-turnover.png" width="39" height="39" alt="total icon" />
                  </div>
                  <label>{{ $t(`label.turnoverRecors`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="routeTo('TRANSFER_RECORD')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-transfer-record.png" width="39" height="39" alt="transfer icon" />
                  </div>
                  <label>{{ $t(`label.transferRecors`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="routeTo('BONUS')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-bonus.png" width="39" height="39" alt="bonus icon" />
                  </div>
                  <label>{{ $t(`label.bonus`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="routeTo('TRANSACTION')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-transaction-record.png" width="39" height="39" alt="transaction icon" />
                  </div>
                  <label>{{ $t(`label.transactionRecors`) }}</label>
                </div>
              </div>
            </div>
            <div class="profile-sheet-item">
              <div class="profile-sheet-item-header">
                <div class="profile-sheet-item-title">{{ $t(`label.rewards`) }}</div>
              </div>
              <div class="profile-sheet-item-divider"></div>
              <div :class="$vuetify.breakpoint.mdAndDown ? 'profile-sheet-item-row-mobile' : 'profile-sheet-item-row'">
                <!-- <div class="profile-sheet-item-column" @click="routeTo('DAILY_CHECK_IN')">

                </div> -->
                <div class="profile-sheet-item-column" @click="routeTo('DEPOSIT')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/icon-depositfreecoin.png" width="39" height="39" alt="checkin icon" />
                  </div>
                  <label>{{ $t(`label.depositgetfreecoin`) }}</label>
                </div>

                <div class="profile-sheet-item-column" @click="routeTo('REWARDS')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/icon_Daily%20Check%20In.png" width="39" height="39" alt="checkin icon" />
                  </div>
                  <label>{{ $t(`label.dailyCheckIn`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="$vuetify.breakpoint.mdAndDown ? routeTo('MWOF') : routeTo('WOF')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/icon-wof.png" width="39" height="39" alt="lucky spin" />
                  </div>
                  <label>{{ $t(`label.fortuneSpin`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="routeTo('CLAIM_VOUCHER')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/icon_Claim%20Voucher.png" width="39" height="39" alt="grabcoin icon" />
                  </div>
                  <label>{{ $t(`label.claimVoucher`) }}</label>
                </div>
                <!--                <div disabled class="profile-sheet-item-column disbaledDiv">-->
                <!--                  <div class="profile-sheet-icon">-->
                <!--                    <img src="/static/image/profile/icon_Coin%20Carnival.png" alt="coin carnival" />-->
                <!--                  </div>-->
                <!--                  <label>{{ $t(`label.coinCarnival`) }}</label>-->
                <!--                </div>-->
              </div>
            </div>
            <div class="profile-sheet-item">
              <div class="profile-sheet-item-header">
                <div class="profile-sheet-item-title">{{ $t(`label.profile`) }}</div>
              </div>
              <div class="profile-sheet-item-divider"></div>
              <div :class="$vuetify.breakpoint.mdAndDown ? 'profile-sheet-item-row-mobile' : 'profile-sheet-item-row'">
                <div class="profile-sheet-item-column" @click="routeTo('PERSONAL')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-personal-info.png" width="39" height="39" alt="info icon" />
                  </div>
                  <label>{{ $t(`label.personalInfo`) }}</label>
                </div>
                <div v-if="!telegramLogin" class="profile-sheet-item-column" @click="routeTo('CHANGE_PASSWORD')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-change-password.png" width="39" height="39" alt="reset icon" />
                  </div>
                  <label>{{ $t(`label.changePassword`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="routeTo('BANK_DETAIL')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-bank-details.png" width="39" height="39" alt="info icon" />
                  </div>
                  <label>{{ $t(`label.bankDetail`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="routeTo('INBOX')">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-inbox-message.png" width="39" height="39" alt="inbox icon" />
                  </div>
                  <label>{{ $t(`label.inbox`) }}</label>
                </div>
                <!--                <div class="profile-sheet-item-column" @click="routeTo('REFERRAL_SUMMARY')">-->
                <!--                  <div class="profile-sheet-icon">-->
                <!--                    <img src="/static/image/profile/profile-referral.png" width="39" height="39" alt="referral" />-->
                <!--                  </div>-->
                <!--                  <label>{{ $t(`label.referral`) }}</label>-->
                <!--                </div>-->
                <!--                <div class="profile-sheet-item-column" v-if="affiliateBonus.status == 1"-->
                <!--                     @click="routeTo('REFERRAL_BONUS')">-->
                <!--                  <div class="profile-sheet-icon">-->
                <!--                    <img src="/static/image/profile/profile-referral-bonus.png" width="39" height="39" alt="referral icon" />-->
                <!--                  </div>-->
                <!--                  <label>{{ $t(`label.referralBonus`) }}</label>-->
                <!--                </div>-->
              </div>
            </div>
            <div class="profile-sheet-item">
              <div class="profile-sheet-item-header">
                <div class="profile-sheet-item-title">{{ $t(`label.contactUs`) }}</div>
              </div>
              <div class="profile-sheet-item-divider"></div>
              <div :class="$vuetify.breakpoint.mdAndDown ? 'profile-sheet-item-row-mobile' : 'profile-sheet-item-row'">
                <div class="profile-sheet-item-column" @click="showIntercomLC()">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-supports.png" width="39" height="39" alt="support icon" @click="showIntercomLC()" />
                  </div>
                  <label>{{ $t(`label.support`) }}</label>
                </div>
                <!--                <div disabled class="profile-sheet-item-column disbaledDiv" @click="routeTo('WHATSAPP', true)">-->
                <!--                  <div class="profile-sheet-icon">-->
                <!--                    <img src="/static/image/profile/icon-whatsapp.svg" alt="whatsapp icon"/>-->
                <!--                  </div>-->
                <!--                  <label>{{ $t(`label.whatsApp`) }}</label>-->
                <!--                </div>-->
                <div class="profile-sheet-item-column" @click="routeTo('TELEGRAM', true)">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/icon-telegram.png" width="39" height="39" alt="telegram icon" />
                  </div>
                  <label>{{ $t(`label.telegram`) }}</label>
                </div>
                <div class="profile-sheet-item-column" @click="routeTo('FACEBOOK', true)">
                  <div class="profile-sheet-icon">
                    <img src="/static/image/profile/profile-fb.png" width="39" height="39" alt="facebook icon" />
                  </div>
                  <label>{{ $t(`label.facebook`) }}</label>
                </div>
              </div>
            </div>
            <div class="profile-sheet-item" v-if="isAndroid || isDesktop">
              <div class="profile-sheet-item-header">
                <div class="profile-sheet-item-title">{{ $t(`label.download`) }}</div>
              </div>
              <div class="profile-sheet-item-divider"></div>
              <div :class="$vuetify.breakpoint.mdAndDown ? 'profile-sheet-item-row-mobile' : 'profile-sheet-item-row'">
                <div class="profile-sheet-item-column" @click="downloadAPK">
                  <div class="profile-sheet-icon">
                    <img width="39" height="39" src="/static/image/profile/profile-logout.png" alt="download apk icon" />
                  </div>
                  <label>{{ $t(`label.downloadandroid`) }}</label>
                </div>
              </div>
            </div>
            <div class="logout-container">
              <div class="logout-btn" @click="logoutBtn">
                <div class="logout-icon"></div>
                <div>{{ $t(`label.logout`) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { ROUTE_NAME } from '@/constants/route.constants'
import { MEMBER_DETAIL, MEMBER_WALLET, MEMBER_VIP_TIER_PROGRESS, MEMBER_GET_VIP_PROGRESS, MEMBER_VIP_TIER_COMMUNICATION, MEMBER_RESET_VIP_TIER_COMMUNICATION } from '@/store/member.module'
import { locale, errorCodeHelper, uiHelper } from '@/util'
import { AFFILIATE_ONE_TIME_BONUS_DETAIL } from '@/store/affiliate.bonus.module'
import { SHARED } from '@/constants/constants'

export default {
  name: 'ProfileSheet',
  props: {
    showProfileSheet: {
      type: Boolean,
      required: true,
      default: false
    },
    closeProfileSheet: {
      type: Function,
      required: false
    },
    logout: {
      type: Function,
      required: false
    }
  },
  data: () => ({
    showVoucherGuide: true,
    currentDeposit: 0,
    requiredDeposit: 0,
    showProgress: false,
    tierBarBgColor: '',
    tierBarColor: '',
    tierColorThemeName: 'starter',
    tierName: '',
    currentProgressPercentage: 0,
    currentLv: 0,
    nextLv: 0,
    progressRequired: 0,
    turnoverRequired: 0,
    nextlevelname: '',
    routeName: ROUTE_NAME,
    notLoading: true,
    currentCurrency: uiHelper.getCurrency(),
    showBalance: true,
    isAndroid: uiHelper.isAndroid(),
    isDesktop: uiHelper.getPlatform() == 'desktop'
  }),
  created() {
    if (this.isLoggedIn) {
      this.getMemberDetail()
      this.getVipTierProgress()
      this.getVipProgress()
    }
  },
  computed: {
    vipTierUpgrade() {
      return this.$store.state.member.vipTierProgress.upgrade
    },
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing
    },
    vipProgress() {
      return this.$store.state.member.vipProgress
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    memberWallet() {
      return this.$store.state.member.walletBalance
    },
    affiliateBonus() {
      return this.$store.state.affiliateBonus.affiliateBonusDetail
    },
    currentLvlName() {
      return this.vipProgress.current_level_name
    },
    communicationLink() {
      return this.$store.state.member.vipTierCommunication.success
    },
    telegramLogin() {
      return this.$store.state.member.info.defaultRegType == SHARED.LOGIN_TYPE_TELEGRAM
    }
  },

  methods: {
    showIntercomLC() {
      Intercom('show');
      return false;
    },
    closeShowVoucherGuide() {
      this.showVoucherGuide = false
    },
    openLiveChat() {
      window.open('https://direct.lc.chat/15455814/', 'Live Chat', 'width=350,height=600')
    },
    getVipProgress() {
      if (this.isLoggedIn) {
        this.$store.dispatch(MEMBER_GET_VIP_PROGRESS)
      }
    },
    goToTierDetails() {
      this.$router.push({ name: this.routeName.VIPTIER })
      this.closeProfileSheet()
    },
    goToReferral() {
      this.$router.push({ name: this.routeName.REFERRAL_SUMMARY })
      this.closeProfileSheet()
    },
    getVipTierProgress() {
      this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
    },
    getAffiliateBonusDetail() {
      this.$store.dispatch(`${AFFILIATE_ONE_TIME_BONUS_DETAIL}`)
    },
    maskBalance() {
      this.showBalance = !this.showBalance
    },
    getMemberDetail() {
      this.$store.dispatch(`${MEMBER_DETAIL}`)
    },
    getMemberWallet() {
      const lastDispatchTime = sessionStorage.getItem('lastDispatchTime')

      if (!lastDispatchTime || Date.now() - parseInt(lastDispatchTime) > 15 * 1000) {
        this.notLoading = false
        sessionStorage.setItem('lastDispatchTime', Date.now()) // Update last dispatch time in sessionStorage
        this.$store.dispatch(MEMBER_WALLET)
      }

      this.maskBalance()
    },
    getVipCommunicationLink(type) {
      let communicationUrl = {
        type: type
      }

      this.$store.dispatch(`${MEMBER_VIP_TIER_COMMUNICATION}`, { communicationUrl })
    },
    logoutBtn() {
      this.logout()
      this.closeProfileSheet()
    },
    routeTo(routeTo, extLink) {
      let params
      this.closeProfileSheet()
      switch (routeTo) {
        case 'DEPOSIT':
          // routeTo = ROUTE_NAME.DEPOSIT

          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.FUNDS
            params = {
              tab: 'deposit',
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.FUNDS
            params = {
              tab: 'deposit'
            }
          }
          break
        case 'WITHDRAWAL':
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.FUNDS
            params = {
              tab: 'withdrawal',
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.FUNDS
            params = {
              tab: 'withdrawal'
            }
          }
          break
        case 'TRANSFER_RECORD':
          // routeTo = ROUTE_NAME.TRANSFER_HISTORY;
          // params = {
          //   tab: "TRANSFER"
          // };
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.TRANSFER_HISTORY
            params = {
              tab: 'TRANSFER',
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.TRANSFER_HISTORY
            params = {
              tab: 'TRANSFER'
            }
          }
          break
        case 'BETTING_RECORD':
          // routeTo = ROUTE_NAME.BETTING_HISTORY;
          // params = {
          //   tab: "TRANSFER"
          // };
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.BETTING_HISTORY
            params = {
              tab: 'TRANSFER',
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.BETTING_HISTORY
            params = {
              tab: 'TRANSFER'
            }
          }
          break
        case 'TURNOVER_RECORD':
          // routeTo = ROUTE_NAME.TURNOVER_RECORD;
          // params = {
          //   tab: "RUNNING"
          // };
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.TURNOVER_RECORD
            params = {
              tab: 'RUNNING',
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.TURNOVER_RECORD
            params = {
              tab: 'RUNNING'
            }
          }
          break
        case 'BONUS':
          // routeTo = ROUTE_NAME.BONUS_HISTORY;
          // params = {
          //   tab: "REBATE"
          // };
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.BONUS_HISTORY
            params = {
              tab: 'REBATE',
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.BONUS_HISTORY
            params = {
              tab: 'REBATE'
            }
          }
          break
        case 'TRANSACTION':
          // routeTo = ROUTE_NAME.TRANSACTION_HISTORY;
          // params = {
          //   tab: "DEPOSIT"
          // };
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.TRANSACTION_HISTORY
            params = {
              tab: 'DEPOSIT',
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.TRANSACTION_HISTORY
            params = {
              tab: 'DEPOSIT'
            }
          }
          break
        case 'PERSONAL':
          // routeTo = ROUTE_NAME.PERSONAL;
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.PERSONAL
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.PERSONAL
          }
          break
        case 'BANK_DETAIL':
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.BANK_ACCOUNT
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.BANK_ACCOUNT
          }
          break
        case 'CHANGE_PASSWORD':
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.CHANGE_PASSWORD
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.CHANGE_PASSWORD
          }
          // routeTo = ROUTE_NAME.CHANGE_PASSWORD;
          break
        case 'INBOX':
          // routeTo = ROUTE_NAME.INBOX;
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.INBOX
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.INBOX
          }
          break
        case 'REFERRAL_SUMMARY':
          // routeTo = ROUTE_NAME.REFERRAL_SUMMARY;
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.REFERRAL_SUMMARY
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.REFERRAL_SUMMARY
          }
          break
        case 'REFERRAL_BONUS':
          // routeTo = ROUTE_NAME.REFERRAL_BONUS;
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.REFERRAL_BONUS
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.REFERRAL_BONUS
          }
          break
        case 'REWARDS':
          // routeTo = ROUTE_NAME.REWARDS;
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.REWARDS
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.REWARDS
          }
          break
        case 'DAILYCHECKIN':
          // routeTo = ROUTE_NAME.DAILYCHECKIN;
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.DAILYCHECKIN
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.DAILYCHECKIN
          }
          break
        case 'CLAIM_VOUCHER':
          //   routeTo = ROUTE_NAME.CLAIM_VOUCHER;
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.CLAIM_VOUCHER
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.CLAIM_VOUCHER
          }
          break
        case 'REBATE':
          // routeTo = ROUTE_NAME.REBATE;
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.REBATE
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.REBATE
          }
          break
        case 'APPLY_AGENT':
          // routeTo = ROUTE_NAME.APPLY_AGENT;
          if (this.$route.params.lang) {
            routeTo = ROUTE_NAME.APPLY_AGENT
            params = {
              lang: this.$route.params.lang
            }
          } else {
            routeTo = ROUTE_NAME.APPLY_AGENT
          }
          break
        case 'MWOF':
          routeTo = ROUTE_NAME.MWOF
          params = {
            lang: this.$route.params.lang
          }
          break
        case 'WOF':
          routeTo = ROUTE_NAME.WOF
          params = {
            lang: this.$route.params.lang
          }
          break
        case 'COIN_CARNIVAL':
          // routeTo = ROUTE_NAME.MWOF
          break
      }

      if (extLink == undefined || !extLink) {
        this.$router.push({
          name: routeTo,
          params
        })
      } else {
        /*external link */
        if (routeTo == 'FACEBOOK') {
          this.getVipCommunicationLink(routeTo)
          // window.open('https://www.facebook.com/nagad88official')
        } else if (routeTo == 'WHATSAPP') {
          this.getVipCommunicationLink(routeTo)
          // window.open('https://bit.ly/NAGAD88_CustomerSupport', '_self')
        } else if (routeTo == 'TELEGRAM') {
          this.getVipCommunicationLink(routeTo)
          // window.open('https://t.me/nagad88official')
        } else if (routeTo == 'LIVECHAT') {
          window.open('mailto:nagad88help@gmail.com/')
        }
      }
    },
    downloadAPK() {
      uiHelper.downloadAPK()
    }
  },
  watch: {
    vipTierUpgrade() {
      if (Object.keys(this.vipTierUpgrade).length > 0) {
        if (this.vipTierUpgrade.current_upgrade_deposit > 0) {
          this.currentProgressPercentage = Math.ceil((this.vipTierUpgrade.current_upgrade_deposit / this.vipTierUpgrade.required_upgrade_deposit) * 100)
        } else {
          this.currentProgressPercentage = 0
        }

        this.progressRequired = this.vipTierUpgrade.required_upgrade_deposit - this.vipTierUpgrade.current_upgrade_deposit
        this.nextlevelname = this.vipTierUpgrade.vip_level_name
      }
      let required = Number(this.vipTierUpgrade.required_upgrade_deposit).toLocaleString()
      required = required.replace(/\.00$/, '')
      let current = Number(this.vipTierUpgrade.current_upgrade_deposit).toLocaleString()
      current = current.replace(/\.00$/, '')
      this.currentDeposit = current

      this.requiredDeposit = required
      this.progressRequired = this.vipTierUpgrade.required_upgrade_deposit - this.vipTierUpgrade.current_upgrade_deposit
      if (this.progressRequired <= 0) {
        this.progressRequired = 'Completed'
      } else {
        this.progressRequired = ' ৳ ' + Number(this.progressRequired).toLocaleString()
      }
      this.nextlevelname = this.vipTierUpgrade.vip_level_name.toLowerCase().replace(/^(.)(.*)$/, function(_, firstLetter, restOfWord) {
        return firstLetter.toUpperCase() + restOfWord.toLowerCase()
      })
      this.turnoverRequired = this.vipTierUpgrade.required_upgrade_turnover - this.vipTierUpgrade.current_upgrade_turnover
      if (this.turnoverRequired <= 0) {
        this.turnoverRequired = 'Completed'
      } else {
        this.turnoverRequired = ' ৳ ' + Number(this.turnoverRequired).toLocaleString()
      }
    },
    memberWallet() {
      this.notLoading = true
    },
    isLoggedIn() {
      this.getAffiliateBonusDetail()
      this.getVipTierProgress()
      this.getMemberDetail()
      this.getVipProgress()
    },
    memberVipTierProgress() {
      let vipTierProgress = this.$store.state.member.vipTierProgress
      if (Object.keys(vipTierProgress.pairing).length > 0) {
        let curPairing = vipTierProgress.pairing
        //progress found
        this.showProgress = true
        switch (curPairing.level_sequence) {
          case 0:
            this.tierColorThemeName = 'starter'
            break
          case 1:
            this.tierColorThemeName = 'bronze'
            break
          case 2:
            this.tierColorThemeName = 'silver'
            break
          case 3:
            this.tierColorThemeName = 'gold'
            break
          case 4:
            this.tierColorThemeName = 'platinum'
            break
          case 5:
            this.tierColorThemeName = 'diamond'
            break
          case 6:
            this.tierColorThemeName = 'black'
            break
          default:
            this.tierColorThemeName = 'starter'
            this.tierBarBgColor = '#1867c0'
        }
        this.tierBarBgColor = 'viptier' + this.tierColorThemeName
        this.tierName = curPairing.name
        this.currentLv = this.memberVipTierProgress.level_sequence
        this.nextLv = this.memberVipTierProgress.level_sequence + 1
      } else {
        //no progress
        this.showProgress = false
      }
    },
    communicationLink() {
      if (this.$store.state.member.vipTierCommunication.success) {
        window.open(this.$store.state.member.vipTierCommunication.data)
        this.$store.dispatch(`${MEMBER_RESET_VIP_TIER_COMMUNICATION}`)
      }
    }
  }
}
</script>

<style lang="scss">
.guideSectionProfile {
  padding: 12px;
  position: relative;
  background: #e2e2e2;
}
.linkText {
  color: #0039f6 !important;
}
.progress-details-col {
  font-size: 15px;
}

.balance-details {
  height: 190px;
  color: #915e51;
  font-style: normal;
  font-weight: 600;
  /*height: 100px;*/
  /*padding-top: 12px;*/
  .MB-row {
    /*height: 100%;*/
    align-items: center;

    .MB-left-col {
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px 0px;

      .highlighted-span {
        font-size: 16px;
      }

      .left-col-btm-row {
        //gap: 8px 0px;
      }
    }

    .MB-right-col {
      flex-direction: column;
      gap: 8px 0px;
    }
  }
  &.starter {
    background-image: url('/static/image/profile/starter_bg.png');
    //box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    height: auto;
    color: #0e1871 !important;
  }
  &.bronze {
    background-image: url('/static/image/profile/bronze_bg.png');
    //box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
    height: auto;
    color: #712f0e !important;
  }

  &.silver {
    background-image: url('/static/image/profile/silver_bg.png');
    //aspect-ratio: 500 / 400;
    height: auto;
    color: #2d2d2d !important;
  }

  &.gold {
    background-image: url('/static/image/profile/gold_bg.png');
    color: #532d00 !important;
    height: auto;
  }

  &.platinium {
    background-image: url('/static/image/profile/platinium_bg.png');
    color: #003157 !important;
    height: auto;
  }

  &.diamond {
    background-image: url('/static/image/profile/diamond_bg.png');
    color: #190046 !important;
    height: auto;
  }

  &.black {
    background-image: url('/static/image/profile/black_bg.png');
    color: #1e0054 !important;
    height: auto;
  }

  .MB-btm-row {
    padding-top: 10px;
    padding-bottom: 10px;
    align-items: center;
    font-style: normal;
    color: #fff;
    //border-top: 0.5px solid #fff;
    background-color: rgba(240, 240, 240, 0.5);
  }
}

.customized-progressbar {
  height: 14px !important;
  background: #1e0054;
  border-radius: 15px;
  padding: 3px;

  .v-progress-linear__determinate.primary {
    max-width: 97%;
  }

  .v-progress-linear__determinate {
    left: 5px;
    height: 7px;
  }
}
.customized-progressbar.starter {
  .v-progress-linear__determinate.primary {
    background-image: linear-gradient(#ffffff, #bcbcbc) !important;
  }
}

.customized-progressbar.bronze {
  .v-progress-linear__determinate.primary {
    background-image: linear-gradient(#eeaf88, #b75c2d) !important;
  }
}

.customized-progressbar.silver {
  .v-progress-linear__determinate.primary {
    background-image: linear-gradient(#d5d5d5, #9c9c9c) !important;
  }
}

.customized-progressbar.gold {
  .v-progress-linear__determinate.primary {
    background-image: linear-gradient(#f0b43b, #b56923) !important;
  }
}

.customized-progressbar.platinium {
  .v-progress-linear__determinate.primary {
    background-image: linear-gradient(#93d1e8, #468296) !important;
  }
}

.customized-progressbar.diamond {
  .v-progress-linear__determinate.primary {
    background-image: linear-gradient(#bb95ff, #6d4bae) !important;
  }
}

.customized-progressbar.black {
  .v-progress-linear__determinate.primary {
    background-image: linear-gradient(#ffab2d, #ff7700) !important;
  }
}

.profile-progress {
  height: 12px;
}

.containerimg {
  position: relative;
  display: flex;
  justify-content: center;
}

.text-overlay {
  color: var(--v-primary-base);
  position: absolute;
  top: 30%;
  left: 46%;
  text-align: center;
  color: var(--v-primary-base);
}

.profile-rightside {
  position: absolute;
  right: 4%;
  color: #fff;
  top: 29%;
  font-size: 10px;
}

.profile-sheet {
  $top: -35vw;

  position: relative;
  background-color: var(--v-base-base) !important;
  overflow-y: auto;
  overflow-x: hidden;

  .profile-sheet-wrapper {
    max-width: 959px;
    margin: auto;

    .profile-sheet-header {
      position: relative;
      height: 45.3333333333vw;
      overflow: hidden;
      background-position-y: -30vw;
      background: url('/static/image/profile/banner-curve.png');
      //background-size: contain;
      background-attachment: fixed;
      background-repeat: no-repeat;

      .profile-sheet-header-image {
        top: 0;
      }

      .profile-sheet-header-wrapper {
        max-width: 1240px;
        margin: auto;

        .profile-sheet-close-wrapper {
          position: absolute;
          top: -32px;
          right: -32px;
          padding: 42px;
          border-radius: 50%;
          background-color: #fff;
          cursor: pointer;

          .profile-sheet-close-icon {
            position: absolute;
            bottom: 20px;
            left: 20px;
            color: var(--v-primary-base);
          }
        }

        .header-member-name {
          position: absolute;
          left: 8%;
          color: #fff;
          top: 20%;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 12px;

          .profile-sheet-profile-avatar {
            color: var(--v-primary-base);
            font-size: 44px;
            background-color: black;
            box-shadow: 2px 2px 1px 3px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }

    .profile-sheet-body {
      position: relative;
      top: $top;
      left: 0;
      width: 100%;
      background: #fff;

      .profile-sheet-body-wrapper {
        max-width: 1240px;
        margin: auto;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 12px;

        .profile-sheet-item {
          background-color: var(--v-base-lighten1);

          .profile-sheet-item-header {
            padding: 8px;

            .profile-sheet-item-title {
              position: relative;
              font-size: 14px;
              padding-left: 12px;

              &::before {
                content: '';
                position: absolute;
                top: 10%;
                left: 0;
                width: 4px;
                height: 80%;
                background-color: var(--v-primary-base);
              }
            }
          }

          .profile-sheet-item-divider {
            width: 100%;
            height: 1px;
            background-color: var(--v-base-base);
            margin: 2px 0px;
          }

          .profile-sheet-item-row-mobile {
            display: flex;
            align-items: center;
            padding: 0px;
            flex-wrap: wrap;

            .profile-sheet-item-column {
              display: flex;
              flex-direction: column;
              justify-content: start;
              align-items: center;
              align-self: baseline;
              gap: 3px;
              width: 19%;
              cursor: pointer;
              margin: 10px;

              .profile-sheet-icon {
                //width: 36px;
                height: 36px;
                //border-radius: 50%;
                background-color: rgba(255, 255, 255, 0.3);
              }

              label {
                font-size: 11px;
                text-align: center;
              }
            }
          }

          .profile-sheet-item-row {
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 0px;
            flex-wrap: wrap;

            .profile-sheet-item-column {
              display: flex;
              flex-direction: column;
              justify-content: start;
              align-items: center;
              align-self: baseline;
              gap: 5px;
              width: 11%;
              cursor: pointer;
              margin: 10px;

              .profile-sheet-icon {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                background-color: rgba(255, 255, 255, 0.3);
              }

              label {
                font-size: 12px;
                text-align: center;
              }
            }
          }

          .disbaledDiv {
            pointer-events: none;
            opacity: 0.4;
          }
        }

        .profile-sheet-wallet {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 16px;
          font-size: 12px;

          .profile-sheet-balance {
            display: flex;
            gap: 4px;

            label {
              color: #0047ff;
              align-self: center;
            }

            .mask-balance {
              color: #000;
              cursor: pointer;
            }

            .refresh-balance-icon {
              width: 24px;
              height: 24px;
              background-color: #000;
              mask: url(/static/image/profile/icon-refresh-type01.svg);
              mask-repeat: no-repeat;
              mask-position: center;
              -webkit-mask: url(/static/image/profile/icon-refresh-type01.svg);
              -webkit-mask-repeat: no-repeat;
              -webkit-mask-position: center;
              cursor: pointer;
            }
          }

          .balance {
            color: #aaa;
            font-size: 18px;
          }
        }
      }
    }

    .logout-container {
      background-color: var(--v-base-lighten1);
      padding: 12px;
      display: flex;
      justify-content: center;
      align-items: center;

      .logout-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        cursor: pointer;

        .logout-icon {
          width: 28px;
          height: 28px;
          background-color: var(--v-text_color-base);
          mask: url(/static/image/profile/icon-logout.svg);
          mask-repeat: no-repeat;
          mask-position: center;
          -webkit-mask: url(/static/image/profile/icon-logout.svg);
          -webkit-mask-repeat: no-repeat;
          -webkit-mask-position: center;
          cursor: pointer;
        }
      }
    }
  }
}

@media (min-width: 960px) {
  .profile-sheet-header {
    height: 55.3333333333vw !important;
  }
  .profile-rightside {
    top: 15%;
  }
  .profile-sheet .profile-sheet-wrapper .profile-sheet-header .profile-sheet-header-wrapper .header-member-name {
    top: 13%;
  }
}

@media (max-width: 959px) {
  $top: -25vw;

  .profile-sheet-header {
    background-position-y: $top !important;
    height: 59.3333333333vw !important;
  }

  .profile-sheet-body {
    top: $top !important;
  }
}

@media (max-width: 599px) {
  $top: -10vw;

  .profile-sheet-header {
    background-position-y: $top !important;
    height: 45.33vw !important;
  }

  .profile-sheet-body {
    top: $top !important;
  }

  .profile-sheet-wallet {
    padding: 16px 4px !important;
  }
}

@media (max-width: 440px) {
  .profile-sheet .profile-sheet-wrapper .profile-sheet-header .profile-sheet-header-wrapper .header-member-name .profile-sheet-profile-avatar {
    height: 60px !important;
    width: 60px !important;
    min-width: 60px !important;
  }
  .vip-tier-current {
    height: 70px !important;
    min-width: 48px;
    width: 110px !important;
    margin-top: 10px;
  }
  .balance-details .MB-row .MB-left-col .highlighted-span {
    font-size: 13px;
  }
  .progress-details-col {
    font-size: 12px;
  }
  .customized-progressbar .v-progress-linear__determinate.primary {
    max-width: 96%;
  }
}
</style>
